const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnRecordDownloadHover(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1724",
    d: "M9.294 13.707a1 1 0 0 0 1.415 0l4-4a1 1 0 0 0-1.414-1.414l-2.3 2.3V1A1 1 0 1 0 9 1v9.585L6.708 8.292a1 1 0 0 0-1.414 1.415z",
    transform: "translate(5.001 5.998)",
    style: {
      fill: "#4495ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1725",
    d: "M19 10a1 1 0 0 0-1 1v5H2v-5a1 1 0 0 0-2 0v5.468A1.622 1.622 0 0 0 1.729 18h16.542A1.622 1.622 0 0 0 20 16.467V11a1 1 0 0 0-1-1",
    transform: "translate(5.001 5.998)",
    style: {
      fill: "#4495ff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRecordDownloadHover);
export default __webpack_public_path__ + "static/media/btn-record-download-hover.70a87784e2f0dbf275cecf540d2e1335.svg";
export { ForwardRef as ReactComponent };